import React from "react";
import { useTranslation } from "react-i18next";
import translations from "../../../utils/language/translations.json";

function ActionModal({ isVisible, title, message, children, onCancel, onConfirm }) {
    const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
    const currentLang = i18n.language; // Access the current language
 
    
    // Safe translation function
    const t = (key) => {
      if (!translations.CardGrid || !translations.CardGrid[key]) {
        console.warn(`Missing translation key: ${key}`); // Log missing keys
        return key; // Return the key as fallback instead of breaking the app
      }
    
      return translations.CardGrid[key][currentLang] || key;
    };
  if (!isVisible) return null;

  return (
    <div className={`confirmation-modal ${isVisible ? "open" : "closed"}`}>
      <div className="modal-content">
        <h3 className="modal-title">{title}</h3>
        <p className="modal-message">{message}</p>

        {/* Dynamically Render Additional Content */}
        {children !== null && children !== undefined && (
        <div className="modal-content">{children}</div>
      )}
        {onConfirm && (
  <div className="btns" style={{minWidth:'4rem'}}>
    <button className="confirm-btn" onClick={onConfirm}>
      {t("Confirm")}
    </button>
    <button className="cancel-btn" onClick={onCancel}>
      {t("Cancel")}
    </button>
  </div>
)}
      </div>
    </div>
  );
}

export default ActionModal;
